import config from "@/config";
import http from "@/utils/request";

export default {
	task: {
		list: {
			url: `${config.API_URL}/admin/task/getList`,
			name: "获取任务列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		getConditionTypes: {
			url: `${config.API_URL}/admin/task/getConditionTypes`,
			name: "获取任务条件类型列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/task/detail`,
			name: "获取任务详情",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		create: {
			url: `${config.API_URL}/admin/task/create`,
			name: "创建任务",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/task/update`,
			name: "更新任务",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/task/delete`,
			name: "删除任务",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		updateStatus: {
			url: `${config.API_URL}/admin/task/updateStatus`,
			name: "更新任务状态",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
};
